import { render, staticRenderFns } from "./videoContainer.vue?vue&type=template&id=400dfd72&scoped=true&"
import script from "./videoContainer.vue?vue&type=script&lang=js&"
export * from "./videoContainer.vue?vue&type=script&lang=js&"
import style0 from "./videoContainer.vue?vue&type=style&index=0&id=400dfd72&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400dfd72",
  null
  
)

export default component.exports